import { Close } from '@mui/icons-material';
import { Grid, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { WsColors, WsTypography, WsTypoVariants, WsIconPublish, WsTypoColors } from 'wisestep-base';

import { useWorkspaceContext } from '../../../context';
import { JobBoardsAction, useJobAccessControl } from '../../../hooks/useJobAccessControl';
import { careerPageSettingStore } from '../../../utils/careerPageSettingsStore';
import socialMediaShareUrl from '../../../utils/shareUrl';
import useJob from '../hooks/useJob';
import PostOnSocialMedia from '../publish/components/socialMedia/PostOnSocialMedia';
import JobPageParams from '../types/JobPageParams';

import FreeJobBoardsList from './components/freeJobBoards/freeJobBoardsList/FreeJobBoardsList';
import PremiumJobBoardAccounts from './components/premiumJobBoards/PremiumJobBoardAccounts';

const Publish = () => {
  const navigate = useNavigate();
  const navigateToAddAccount = () => navigate(`/jobs`);
  const params = useParams<JobPageParams>();
  const [jobId, setJobId] = useState(params.jobId ?? '');
  const [jobDetails, isLoading] = useJob(jobId);
  const pageRefresh = () => setJobId(jobId);

  const careerPageSetting = careerPageSettingStore((state) => state.careerPageSettings);

  const workspaceContext = useWorkspaceContext();
  const { access: jobAccesControl } = useJobAccessControl([
    JobBoardsAction.FREE_JOB_BOARDS,
    JobBoardsAction.PREMIUM_JOB_BOARDS,
  ]);

  const freeJobAccess = workspaceContext.owns || jobAccesControl[0];
  const premiumJobAccss = workspaceContext.owns || jobAccesControl[1];

  return (
    <Box bgcolor={WsColors.BorderGrey} p={3}>
      <Grid container my={2}>
        <Grid item xs={3} container justifyContent="flex-start">
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>Publish job on</WsTypography>
        </Grid>
        <Grid item xs={9} container justifyContent="flex-end">
          <Stack direction="row" spacing={2} alignItems="right">
            {jobDetails?.postedOnJobBoards && (
              <WsTypography
                variant={WsTypoVariants.SUB_TITLE}
                display="inline"
                color={WsTypoColors.PRIMARY}
                bold
              >
                <WsIconPublish color={WsColors.TheBlues500} />
                {` ${jobDetails?.postedOnJobBoards.length} of 21 Boards`}
              </WsTypography>
            )}
            {jobDetails?.title && (
              <WsTypography
                variant={WsTypoVariants.SUB_TITLE}
                display="inline"
                color={WsTypoColors.BLACK}
              >
                {jobDetails?.title}
              </WsTypography>
            )}
            {jobDetails?.jobCode && (
              <WsTypography
                display="inline"
                variant={WsTypoVariants.SUB_TITLE}
                color={WsTypoColors.SECONDARY}
              >
                {jobDetails.jobCode}
              </WsTypography>
            )}
            <Close
              onClick={navigateToAddAccount}
              fontSize="large"
              color="action"
              sx={{ cursor: 'pointer', pb: 1 }}
            />
          </Stack>
        </Grid>
      </Grid>
      <Grid item container spacing={4}>
        {jobDetails && !isLoading && (
          <>
            {freeJobAccess && (
              <Grid item xs={3.6}>
                <FreeJobBoardsList
                  job={jobDetails}
                  pageRefresh={pageRefresh}
                  jobId={jobDetails.id ?? ''}
                />
              </Grid>
            )}
            {premiumJobAccss && (
              <Grid item xs={4.8}>
                <PremiumJobBoardAccounts jobData={jobDetails} />
              </Grid>
            )}
            <Grid item xs={3.6}>
              <PostOnSocialMedia
                shareUrl={socialMediaShareUrl(jobDetails, careerPageSetting)}
                title={''}
                job={jobDetails}
              />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default Publish;
